import { Link } from 'react-router-dom';

interface LinkCellProps {
  icon: string;
  link: string;
}

const VisitLinkCell: React.FC<LinkCellProps> = ({ link, icon }) => {
  return (
    <Link to={link} className="btn btn-ghost-purple">
      <i className={`${icon} fs-14`} />
    </Link>
  );
};

export default VisitLinkCell;
